/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useModalForm } from "@refinedev/antd";
import {
  BaseRecord,
  useNotification
} from "@refinedev/core";
import { Form, Table } from "antd";
import { ColumnType } from "antd/es/table";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModalForm as useModalFormAntd } from "sunflower-antd";

import { useCreateWallet, useGetListWallet } from "../../../../api/wallet";
import { NewWalletModalCreate } from "../../../../components/modal/admin/addWallet";
import { EditWalletModal } from "../../../../components/modal/admin/editWallet";
import { useIsAdminRole } from "../../../../utils/hooks/useIdentityAdmin.hook";
import { ButtonListHeader } from "../../../components/buttonsList";
import { Row } from "../../../components/interface";
import { TableForm } from "../../../crypto-withdrawal/tableForm";
import "../../../styles/index.css";

const start = 0;
const end = 10;

interface IProps {
  companyId?: number;
  isActive?: boolean;
  userId?: number;
}

export const CompanyWallets: React.FC<IProps> = ({ companyId, isActive = true, userId }) => {
  const { open: openNotificationWallet } = useNotification();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState<number>();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState<string>();
  const [params, setParams] = useState({
    start,
    end,
  });

  const {
    data = {
      data: {
        data: { items: [], total: 0, totalPages: 0, pageSize: 0, page: 0 },
      },
    },
    isLoading: loadingGetList,
    refetch: refetchCompanyWallet,
  } = useGetListWallet({
    companyId: companyId || 0,
    start: params.start,
    end: params.end,
    name: searchName,
    enabled: isActive && !!companyId,
  });

  const isAdminRole = useIsAdminRole();

  const handleSearch = () => {
    const searchValue = form.getFieldValue('searchValue');
    setSearchName(searchValue || undefined);
    setCurrentPage(1);
    setParams({
      start,
      end,
    });
  };

  const handlePageChange = (page: number) => {
    navigate(`/company/${companyId}?pageSize=10&current=${page}`);
    setCurrentPage(page);
    setParams({
      start: (page - 1) * (data?.data?.data?.pageSize || 10),
      end: page * (data?.data?.data?.pageSize || 10),
    });
  };

  const {
    modalProps: createWalletModalProps,
    formProps: createWalletFormProps,
    show: createWalletModalShow,
    close: createWalletModalClose,
  } = useModalForm({
    warnWhenUnsavedChanges: false,
    action: "create",
  });

  const {
    close: editModalClose,
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
  } = useModalFormAntd({});

  const { mutate: createWallet, isLoading: isLoadingCreate } = useCreateWallet({
    onSuccess: (response: { data: { message: string } }) => {
      if (openNotificationWallet) {
        openNotificationWallet?.({
          key: "success_transaction_confirm",
          message: response.data.message || "Add wallet successfully!",
          type: "success",
        });
      }
      refetchCompanyWallet();
      createWalletModalClose();
      createWalletFormProps?.form?.resetFields();
    },
    onError: (error: { message: string }) => {
      if (openNotificationWallet) {
        openNotificationWallet({
          key: "add_wallet_failure",
          message: error?.message || "Add wallet failed!",
          type: "error",
        });
      }
    },
  });

  const handleClickOnCell = (record: BaseRecord) => {
    return {
      onClick: () => {
        if (record.id && isAdminRole) {
          setEditingId(Number(record.id));
        }
      },
    };
  };

  const columns: ColumnType<Row>[] = [
    {
      dataIndex: "id",
      title: "NO.",
      onCell: handleClickOnCell,
    },
    {
      dataIndex: "name",
      title: "Name",
      onCell: handleClickOnCell,
    },
    {
      dataIndex: "network",
      title: "Network",
      onCell: handleClickOnCell,
      render: (_value: string, record: BaseRecord) => (
        <span>{record?.network?.name}</span>
      ),
    },
    {
      dataIndex: "currency",
      title: "Currency",
      onCell: handleClickOnCell,
      render: (_value: string, record: BaseRecord) => (
        <span>{record?.assetConfigGroup?.symbol}</span>
      ),
    },
    {
      dataIndex: "address",
      title: "Address",
      onCell: handleClickOnCell,
    },
  ];

  if (!companyId) {
    return null;
  }

  return (
    <>
      <div>
        <TableForm
          form={form}
          searchPlaceholder={"Search wallet by name"}
          showDateFilter={false}
          onSubmit={handleSearch}
          headerButtons={
            isAdminRole ? ButtonListHeader(createWalletModalShow) : null
          }
        />
        <Table
          loading={loadingGetList}
          rowKey="id"
          columns={columns}
          dataSource={data?.data?.data?.items}
          pagination={{
            current: currentPage,
            total: data?.data?.data?.total,
            pageSize: data?.data?.data?.pageSize,
            onChange: handlePageChange,
          }}
        />
      </div>
      <NewWalletModalCreate
        closeModal={createWalletModalClose}
        formProps={createWalletFormProps}
        modalProps={createWalletModalProps}
        formIsLoading={isLoadingCreate}
        formSubmit={createWallet}
        companyId={companyId}
        userId={userId}
      />
      <EditWalletModal
        editingId={editingId}
        changeEditingId={setEditingId}
        show={editModalShow}
        formProps={editFormProps}
        modalProps={editModalProps}
        refetchList={refetchCompanyWallet}
        closeModal={editModalClose}
        userId={userId}
      />
    </>
  );
};

